<svg
  width="17"
  height="19"
  viewBox="0 0 17 19"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [ngStyle]="overrideStyle"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.55449 3.43548C8.55449 3.23062 8.41879 3.04602 8.21385 2.96752C8.00613 2.88927 7.76794 2.93258 7.61007 3.07742L5.16459 5.31287C5.05935 5.40783 4.91809 5.46126 4.7713 5.46126H1.90762C1.61405 5.46126 1.33157 5.56786 1.12385 5.75804C0.916137 5.94795 0.799805 6.20548 0.799805 6.47415V10.5257C0.799805 10.7944 0.916137 11.0519 1.12385 11.2418C1.33157 11.432 1.61405 11.5386 1.90762 11.5386H4.7713C4.91809 11.5386 5.05935 11.592 5.16459 11.687L7.61007 13.9224C7.76794 14.0673 8.00613 14.1106 8.21385 14.0323C8.41879 13.9538 8.55449 13.7692 8.55449 13.5644V3.43548Z"
    fill="black"
    fill-opacity="0.6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.1037 4.03333C12.378 4.45621 14.0915 6.29663 14.0915 8.49993C14.0915 10.7032 12.378 12.5436 10.1037 12.9665C9.8043 13.0222 9.61042 13.2899 9.67135 13.5639C9.73228 13.8376 10.025 14.0149 10.3247 13.9592C13.1045 13.4423 15.1993 11.1932 15.1993 8.49993C15.1993 5.80665 13.1045 3.55752 10.3247 3.04069C10.025 2.98499 9.73228 3.16224 9.67135 3.43598C9.61042 3.70996 9.8043 3.97762 10.1037 4.03333Z"
    fill="black"
    fill-opacity="0.6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.4356 5.71478C10.2639 5.64616 10.0673 5.66135 9.90942 5.75504C9.75433 5.84848 9.66016 6.00776 9.66016 6.17869V10.8213C9.66016 10.9922 9.75433 11.1515 9.90942 11.2449C10.0673 11.3386 10.2639 11.3538 10.4356 11.2852C11.6099 10.816 12.4297 9.74482 12.4297 8.49998C12.4297 7.25514 11.6099 6.184 10.4356 5.71478Z"
    fill="black"
    fill-opacity="0.6"
  />
</svg>
